export function padNumber(value: number, maxValue: number): string {
  return value.toString().padStart(maxValue.toString().length, "0");
}
